import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const token = localStorage.getItem("tb_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      localStorage.removeItem("tb_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me if we're in OAuth callback
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    load();
  }, [load]);

  const signIn = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const signUp = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const signInWithGoogleSession = async (session_id) => {
    const r = await api.post("/auth/google/session", { session_id });
    localStorage.setItem("tb_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const signOut = () => {
    localStorage.removeItem("tb_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, signIn, signUp, signOut, signInWithGoogleSession, reload: load }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
